import Layout from "../Shared/Layout";
import FinancingBanner from "./FinancingBanner";
import OfferFinancing from "./OfferFinancing";
const FinancingServicesPage = () => {
    return (
        <Layout>
            <FinancingBanner />
            <OfferFinancing />
        </Layout>
    )
}

export default FinancingServicesPage;